import './styles.scss';

/**
 * import GSAP
 */
import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollSmoother } from "../dist/ScrollSmoother.min.js";

gsap.registerPlugin(ScrollTrigger, ScrollSmoother);



/**
 * import SWIPER
 */
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay} from 'swiper/modules';
import 'swiper/swiper.min.css';



/**
 * Global
 */
const isMobile = () => window.innerWidth <= 768;



/**
 * Swiper sliders
 */
// Sport offers
const sporting = new Swiper('.sporting-offers', {
    loop: false,
    modules: [Navigation, Pagination],
    navigation: {
      nextEl: '.sporting-offer__arrow--right',
      prevEl: '.sporting-offer__arrow--left',
    },
    pagination: {
      el: '.slider-indicator__inner',
      type: 'progressbar',
    },
    breakpoints: {
        375: {
            slidesPerView: 2.19, 
        },
        768: {
            slidesPerView: 5, 
        },
        992: {
            slidesPerView: 5.1, 
        },
        1024: {
            slidesPerView: 3.95, 
        }
    }
});


// Review Small
// const review = new Swiper('.reviews', {
//     loop: true,
//     modules: [Navigation],
//     speed: 750,
//     navigation: {
//       nextEl: '.review-single__arrow--right',
//       prevEl: '.review-single__arrow--left',
//     },
//     slidesPerView: 1
// });


// Review Large
const reviewLarge = new Swiper('.reviews-large', {
    loop: true,
    modules: [Navigation, Autoplay],
    autoplay: { delay: 3500 },
    speed: 1000,
    navigation: {
      nextEl: '.review-large__arrow--right',
      prevEl: '.review-large__arrow--left',
    },
    breakpoints: {
        992: {
            slidesPerView: 1, 
        },
        1024: {
            slidesPerView: 3, 
        }
    }
});


// Review Social Proof
const socialProof = new Swiper('.social-proofs', {
    modules: [Autoplay],
    autoplay: { 
        delay: 3000,
        disableOnInteraction: false
    },
    speed: 1500,
    loop: true,
    breakpoints: {
        576: {
            slidesPerView: 1, 
        },
        992: {
            slidesPerView: 3, 
        }
    }
});



/**
 * ScrollSmoother
 */
ScrollTrigger.normalizeScroll(false);

let smoother = ScrollSmoother.create({
    smooth: 1.4,
    ignoreMobileResize: true,
    smoothTouch: 0.6, 
    effects: true
});


/**
 * Pin Images Animation
 */
// Common ScrollTrigger settings
const pinStartValue = !isMobile() ? "top top+=14%" : "top top+=12%";
const pinAnimationSettings = {
    trigger: ".about",
    start: pinStartValue,
    end: "bottom bottom+=55vh",
    scrub: true
};

// Animation for .about__sticky-images
gsap.to(".about__sticky-images", {
    y: "-100%",
    ease: "none",
    scrollTrigger: {
        ...pinAnimationSettings,
        end: "bottom bottom+=50vh",
        pin: ".about__content", 
    }
});

gsap.to(".sticky-images__list-item--left", {
    rotation: -5,
    ease: "none",
    scrollTrigger: {
        ...pinAnimationSettings,
    }
});

gsap.to(".sticky-images__list-item--right", {
    rotation: 5,
    ease: "none",
    scrollTrigger: {
        ...pinAnimationSettings,
    }
});


/**
 * Sticky Header Animation
 */

const headerStartValue = !isMobile() ? "top+=58px top+=58px" : "top+=58px top+=58px";
gsap.to('header', {
    paddingTop: '0px',
    ease: 'linear',
    scrollTrigger: {
        trigger: 'header',
        start: headerStartValue,
        end: '+=70',
        scrub: true
    }
});

ScrollTrigger.create({
    trigger: "header",
    start: "bottom top+=58px",
    end: "bottom top+=58px",
    onEnter: () => document.querySelector(".navbar").classList.add("scrolled"),
    onLeaveBack: () => document.querySelector(".navbar").classList.remove("scrolled")
});




/**
 * Sticky CTA
 */

if(isMobile) {
    
    ScrollTrigger.create({
        trigger: "header",
        start: "bottom top+=58px",
        end: "bottom top+=58px",
        onEnter: () => {
            document.querySelector(".sticky-cta").classList.add("reveal");
        },
        onLeaveBack: () => {
            document.querySelector(".sticky-cta").classList.remove("reveal");
        }
    });
}

/**
 * Marquee Animation
 */
gsap.set('.call-to-action__marquee-inner span', { x: '0%' }); // Initialize position

gsap.to('.call-to-action__marquee-inner span', {
    x: '-40%',
    duration: 45,
    repeat: -1, // Infinite repeat
    ease: 'linear'
});


/**
 * Image scrubs Animation
 */
const scrubImageLoop = document.querySelectorAll(".image-loop");

if (scrubImageLoop.length) {

    scrubImageLoop.forEach(marqueeContent => {

        const durationValue = !isMobile() ? 100 : 30;

        const marqueeAnimation = gsap.timeline({
            repeat: -1,
            paused: false,
            defaults: {
                duration: durationValue,
                ease: "linear"
            }
        });

        marqueeAnimation.to(marqueeContent.children, { xPercent: -100 });

    });
}


const scrubImageCloser = document.querySelectorAll(".closer__images");

if (scrubImageCloser.length) {

    scrubImageCloser.forEach(marqueeContent => {

        const durationValue = !isMobile() ? 40 : 30;

        const marqueeAnimation = gsap.timeline({
            repeat: -1,
            paused: false,
            defaults: {
                duration: durationValue,
                ease: "linear"
            }
        });

        marqueeAnimation.to(marqueeContent.children, { xPercent: -100 });

    });
}



/**
 * Parallax Animation
 */
function parallaxMedia(target, speed = 0.94) {
    const targetSelectors = document.querySelectorAll(target);

    // Check if target elements exist
    if (targetSelectors.length) {
        gsap.set(target, { willChange: 'transform' });
        smoother.effects(target, { speed: speed });
    }
}

// Usage
parallaxMedia('.call-to-action__image img');
parallaxMedia('.hero__video img');